<template>
  <sui-modal class="log-modal" size="small" v-model="visible" closable>
    <sui-modal-header>
      Backup and Restore
    </sui-modal-header>
    <sui-modal-content v-if="serviceId">
      <sui-tab class="tabs" :activeIndex="mode === 'backup' ? 0 : 1" :menu="{attached: 'top', color: 'blue', widths: 2}" @change="onChange">
        <sui-tab-pane title="Backup" emphasis="secondary">
          <sui-message info size="small" icon="info circle" header="You are going to create database backup on selected provider!">
            The backup files will be saved to: <code style="white-space: nowrap;">{{recoveryFolderPlaceholder}}</code>
          </sui-message>
          <sui-segment emphasis="secondary">
            <sui-form warning>
              <sui-form-fields>
                <sui-form-field :width="14" required>
                  <label>Storage provider</label>
                  <sui-dropdown :class="{disabled: !providersList.length}" search selection fluid :options="providersList" v-model="providerId" />
                </sui-form-field>
                <sui-form-field :width="2">
                  <label style="opacity: 0">.</label>
                  <sui-button class="icon" size="tiny" :disabled="!access.providerCreate" fluid compact data-inverted data-position="left center" data-tooltip="Add new provider" data-goal="BACKUP_SERVICE_NEW_PROVIDER" @click.prevent="$modals.createProvider.open(null, onCreateProvider)">
                    <i class="ui large fitted icons">
                      <i class="cloud fitted icon" />
                      <i class="inverted corner plus fitted icon" />
                    </i>
                  </sui-button>
                </sui-form-field>
              </sui-form-fields>
            </sui-form>
          </sui-segment>
        </sui-tab-pane>
        <sui-tab-pane title="Restore">
          <sui-message warning size="small" icon="exclamation triangle" header="You are going to replace the existing data by the data from your backup!">
            You will not be able to cancel this operation!
          </sui-message>
          <sui-segment emphasis="secondary">
            <sui-form>
              <sui-form-field required>
                <label>Storage Provider</label>
                <sui-dropdown :class="{disabled: !providersList.length}" search selection fluid :options="providersList" v-model="providerId" />
              </sui-form-field>
              <sui-form-field>
                <label>Recovery Folder</label>
                <sui-input v-model="recoveryFolder" fluid :placeholder="recoveryFolderPlaceholder" />
              </sui-form-field>
              <sui-form-field>
                <label>Recovery File</label>
                <sui-input v-model="recoveryFile" fluid placeholder="the latest one if empty" />
              </sui-form-field>
            </sui-form>
          </sui-segment>
        </sui-tab-pane>
      </sui-tab>
      <sui-message error v-if="apiError">
        {{apiError}}
      </sui-message>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button-group>
        <sui-button icon="check" label-position="left" color="green" :disabled="!actions[mode === 'backup' ? 'serviceUpdate' : 'serviceDestroy']" @click="submit()">{{mode === 'backup' ? 'Create backup' : 'Restore'}}</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="close()">Cancel</sui-button>
      </sui-button-group>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        {{mode === 'backup' ? 'Creating backup' : 'Restoring'}} started
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import utils from '@/utils'

  export default {
    name: 'ModalBackup',
    data() {
      return {
        apiError: null,
        success: false,
        visible: false,
        mode: 'backup',
        tabIndex: 0,
        providerId: null,
        serviceId: null,
        recoveryFolder: '',
        recoveryFile: '',
      }
    },
    computed: {
      ...mapGetters(['access', 'actionsById', 'account', 'providers', 'providersById', 'servicesById']),
      actions() {
        return this.serviceId ? this.actionsById[this.serviceId] : {}
      },
      providersList() {
        return this.providers.filter(provider => provider.purpose === 'storage').map(provider => {
          return {
            image: {src: provider._logo},
            text: provider.name,
            value: provider.id,
          }
        })
      },
      service() {
        return this.servicesById[this.serviceId]
      },
      selectedProvider() {
        return this.providersById[this.providerId]
      },
      recoveryFolderPlaceholder() {
        const accountId = this.account.shortId
        const postfix = this.selectedProvider ? this.selectedProvider._backupPostfix : ''
        const service = this.service.name.toLowerCase()
        return `d2c-${accountId}${postfix}/${service}/backups/`
      },
    },
    watch: {
      visible(newValue) {
        if (newValue) {
          this.reset()
        }
      },
    },
    methods: {
      open(mode = 'backup', service) {
        this.visible = true
        this.mode = mode
        this.serviceId = service.id
      },
      close() {
        this.visible = false
      },
      reset() {
        this.apiError = null
        this.success = false
        this.providerId = (this.providersList.length ? this.providersList[0].value : null)
      },
      onChange(event, component, index) {
        this.mode = index ? 'restore' : 'backup'
      },
      onCreateProvider(result) {
        if (result && result.id) {
          this.providerId = result.id
        }
      },
      submit() {
        const data = {
          provider: this.providerId,
          recoveryFolder: this.recoveryFolder || this.recoveryFolderPlaceholder,
          recoveryFile: this.recoveryFile,
        }
        this.apiError = null
        if (this.mode === 'restore') {
          return this.$modals.confirm.open({
            callback: () => {
              utils.reachGoal('RESTORE_SERVICE_TRY')
              return this.service.restore(data).then(() => {
                utils.reachGoal('RESTORE_SERVICE_SUCCESS')
                this.success = true
                this.close()
              }).catch(error => {
                utils.reachGoal('RESTORE_SERVICE_FAIL')
                this.apiError = error.message
              })
            }
          })
        }
        utils.reachGoal('BACKUP_SERVICE_TRY')
        return this.service.backup(data).then(() => {
          utils.reachGoal('BACKUP_SERVICE_SUCCESS')
          this.success = true
          this.close()
        }).catch(error => {
          utils.reachGoal('BACKUP_SERVICE_FAIL')
          this.apiError = error.message
        })
      },
    },
    created() {
      this.$modals.backup = this
    },
  }
</script>

<style scoped>
  .input >>> input[readonly] { opacity: 1!important; }
</style>
